<div>
    <h6>
        {{ l10nKeys.matchLabel | vtranslate : selectedOptions?.length ?? 0 }}
    </h6>
    <avi-component-adder
        class="match-adder sel-match-adder"
        [options]="selectableOptions"
        [selectedComponents]="selectedOptions"
        [disableAdd]="disableAddButton"
        (onAdd)="addMatch($event)"
        noAvailableOptionsLabel="{{ l10nKeys.noAvailableMatchesLabel | vtranslate }}"
        addLabel="{{ globalL10nKeys.addLabel | vtranslate }}"
        noSelectedComponentsLabel="{{ l10nKeys.noEntriesLabel | vtranslate }}"
        indexAlias="matchIndex"
    ></avi-component-adder>
</div>
